import axios from '../helpers/axios';
import type { AppThunk } from '../typings/redux';

export const getSiteTemplatesBySiteType =
  (type: string): AppThunk<Promise<void>> =>
  async (dispatch) => {
    try {
      const res = await axios.get(`/api/site_templates/?type=${type}`);
      dispatch({ type: 'SET_SITE_TEMPLATES_BY_TYPE', payload: { type, data: res.data } });
    } catch (e) {}
  };

export const getSiteTemplates = (): AppThunk<Promise<void>> => async (dispatch) => {
  try {
    const res = await axios.get('/api/site_templates/');
    dispatch({ type: 'SET_ALL_SITE_TEMPLATES', payload: { data: res.data } });
  } catch (e) {}
};

export const deleteSiteTemplateById =
  (data: { id: string }): AppThunk<Promise<void>> =>
  async (dispatch) => {
    try {
      await axios.delete('/api/site_template/', { params: { id: data.id } });
      dispatch({ type: 'REMOVE_SITE_TEMPLATE', payload: data });
    } catch (e) {}
  };
